<template>
  <div id="analise">
    <div class="contant-analise" v-if="!error">
      <div aria-live="assertive" role="alert" class="announce" style="position: absolute; left: -9999px;">
        {{ mensagem }}
      </div>
      <h1 class="titulo">{{titulo}}</h1>
      <p class="subtitulo">{{subtitulo}}</p>
      <div class="animacao">
        <img class="img img-fluid" src="@/assets/img/analise/meuvivo.gif">
      </div>
    </div>

    <div class="page-error" v-if="error">
      <Error
          title="Algo deu errado ao enviar a foto"
          :subtitle="errorSubtitulo"
          button-text="Tirar selfie novamente"
          v-bind:callback="falha"
      ></Error>
    </div>
  </div>
</template>

<script>

import AppService from "../../services/AppService";
import BaseSerasaService from "../../services/BaseSerasaService";
import Error from "../shared/Error";
import jwtDecode from "jwt-decode";

const APROVADO  = 1;
const REPROVADO = 2;

export default {
  name: "ConsultaBaseSerasa",
  components: {Error},
  data:function (){
    return {
      titulo: "Analisando dados enviados",
      subtitulo: 'Continue nesta tela enquanto analisamos',
      errorSubtitulo:'',
      error: false,
      mensagem:''
    }
  },
  computed:{
    getDadosBase1N:function (){
      return this.$store.getters.dados1N;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.validarSelfie();
      vm.validarDadosBase1N();
      if (parseInt(vm.$store.state.ind_api_n1) !== 1) {
        return vm.appService.nextPageLiveness();
      }
      next();
    });
  },
  created() {
    let loading = (this.$store.getters.tempoResposta < 5) ? true : false;
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", loading);
    this.appService = new AppService();
  },
  mounted() {
    this.baseSerasa = new BaseSerasaService();
    this.consultarBase();
  },
  methods:{
    validarSelfie:function (){
      let liveness = parseInt(this.$store.state.liveness);
      let livenessSerasa = (liveness === 3
          && (!sessionStorage.getItem('s')
              || !sessionStorage.getItem('selfie_msg')
              || !sessionStorage.getItem('selfie_id')));
      let livessCaf = (liveness === 4 && !sessionStorage.getItem('s'));
      if(livenessSerasa && livessCaf){
        this.$store.dispatch("limparDadosSelfie");
        this.$router.replace({ name: 'ConfirmarIdentidade' })
      }
    },
    validarDadosBase1N:function (){
      if(this.getDadosBase1N){
        try{
         let dados = jwtDecode(this.getDadosBase1N);
         this.nextPage(dados.resultado)
        }catch (e){
          this.nextPage(-1)
        }
      }
    },
    consultarBase:function (){
      let result = this.baseSerasa.consultarCanaisDigitais();
      result.then(res =>{
        try{
          if(!res || !res.resultado_base1n){
            throw new Error('');
          }
          let dados = jwtDecode(res.resultado_base1n);
          this.$store.dispatch("definirResposta1N", { response: res.resultado_base1n, resultado: dados.ind_capturar_doc });
          this.nextPage(dados.ind_capturar_doc);
        }catch (e){
            throw new Error('Falha ao processar resposta');
        }
      }).catch(error => {
            error.json().then(resError => {
              if(error.status === 422 || !resError.resultado_base1n){
                this.$store.dispatch("limparDadosSelfie");
                this.$store.dispatch("setLoadingStatus", false);
                this.error = true;
                this.errorSubtitulo  = resError.error ? resError.error : 'Falha ao processar sua foto';
                return;
              }
              let dados = jwtDecode(resError.resultado_base1n);
              this.$store.dispatch("definirResposta1N", { response: resError.resultado_base1n, resultado: dados.ind_capturar_doc });
              this.nextPage(dados.ind_capturar_doc);
            }).catch(_ => this.$router.replace({name:'Falha'}));
      })
    },
    nextPage(resultado){
      if(!resultado){
       return this.$router.push({name: 'Analise'});
      }
      this.$router.push({name: 'DocSelecao'});
    },
    falha(){
      this.$store.dispatch("setLoadingStatus", true);
      this.$router.replace({name: 'ConfirmarIdentidade'})
           .then(_ => {
             this.$store.dispatch("setLoadingStatus", true);
             window.location.reload()
           })
          .catch(_ => this.$router.replace({name:'Falha'}));
    }

  }
}
</script>

<style scoped>


.hidden{
  display: none;
}

#analise{
  margin-top: 5rem;
}

.animacao {
  position: relative;
  width: 18.75rem;
  height: 18.75rem;
  margin: 0 auto;
}

.animacao img {
  position: relative;
  height: 100%;
  margin: 0 auto;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/ConsultaBaseSerasa.vue